export var Journeys = {
  GET_STARTED: 'get-started',
  DECIDE: 'decide',
  DISCOVER: 'discover'
};
export var Targets = {
  CONFLUENCE: 'confluence.ondemand',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
  BITBUCKET: 'bitbucket.ondemand',
  TRELLO: 'trello',
  OPSGENIE: 'opsgenie',
  STATUSPAGE: 'statuspage',
  TEAM_CENTRAL: 'townsquare',
  ANALYTICS: 'atlassian-analytics-free'
};

// Temporary -- until cross flow supports CCP Keys